import React, { useCallback, useRef, useState } from 'react';
import { megaMenuPropTypes } from './MegaMenuPropTypes';
import { BREAKPOINTS } from '@Theme/natucare/constants/breakpoints';
import { DEVICE_TYPES } from '@Theme/natucare/constants/deviceTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Icon from '@Theme/natucare/components/Icon/Icon';
import MegaMenuLists from './components/MegaMenuLists/MegaMenuLists';
import MegaMenuProducts from './components/MegaMenuProducts/MegaMenuProducts';
import { useDeviceDetect } from '@App/common/hooks/useDeviceDetect';
import * as styles from './MegaMenu.module.scss';
const megaMenuItemComponents = {
  lists: MegaMenuLists,
  products: MegaMenuProducts
};
const MegaMenu = _ref => {
  let {
    items,
    mobilePreviousLayerLabel,
    isNavItemOpen,
    classname
  } = _ref;
  if (!items) {
    return null;
  }
  const megaMenuRef = useRef(null);
  const {
    deviceType
  } = useDeviceDetect(BREAKPOINTS);
  const isDesktop = deviceType !== DEVICE_TYPES[BREAKPOINTS.XS] && deviceType !== DEVICE_TYPES[BREAKPOINTS.SM] && deviceType !== DEVICE_TYPES[BREAKPOINTS.MD];
  const handleStopPropagation = e => {
    const navLabel = e.target.closest(`.${styles.rootNavLabel}`);
    if (!navLabel) {
      e.stopPropagation();
    }
  };
  const {
    0: isNestedItemOpened,
    1: setIsNestedItemOpened
  } = useState(false);
  const handleNestedStateChange = useCallback(isOpen => {
    if (isDesktop) {
      return;
    }
    setIsNestedItemOpened(isOpen);
    if (isOpen) {
      megaMenuRef.current.scrollTop = 0;
    }
  }, [deviceType]);
  const rootClassnames = `
    ${styles.root} 
    ${isNavItemOpen ? styles.rootMobileOpened : ''}
    ${isNestedItemOpened ? styles.rootOverflowHidden : ''}
    ${classname || ''}
  `;
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassnames,
    ref: megaMenuRef,
    onClick: handleStopPropagation
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, mobilePreviousLayerLabel && /*#__PURE__*/React.createElement("span", {
    className: styles.rootNavLabel
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootNavLabelIcon,
    size: {
      width: 8,
      height: 14
    },
    name: "arrowNav"
  }), mobilePreviousLayerLabel), Object.entries(items).map((_ref2, index) => {
    let [key, value] = _ref2;
    const MegaMenuItem = megaMenuItemComponents[key];
    return MegaMenuItem && /*#__PURE__*/React.createElement(MegaMenuItem, {
      items: value,
      handleNestedStateChange: handleNestedStateChange,
      key: index
    });
  })));
};
export default MegaMenu;